import AppCheckbox from "@/app/components/atomic/Input/AppCheckbox"
import ConsentRegulatoryNotice from "@/app/components/atomic/molecules/ConsentRegulatoryNotice"

// "loan" = AE, "health" = MS; "legacy" garde le wording d'origine des modales jusqu'au plan 09
export type ContactConsentVariant = "legacy" | "loan" | "loanCallback" | "health" | "provident"

interface ConsentCheckboxCopy {
    phoneLabel: string
    phoneSub?: string
    phoneRequired?: boolean
    emailLabel: string
    emailSub?: string
}

const COPY: Record<ContactConsentVariant, ConsentCheckboxCopy> = {
    legacy: {
        phoneLabel: "J'accepte d'être contacté(e) par téléphone par les partenaires de Réassurez-moi afin de traiter ma demande et de me présenter leurs offres d'assurance.",
        emailLabel: "J'accepte d'être contacté(e) par email par les partenaires de Réassurez-moi afin de traiter ma demande et de me présenter leurs offres d'assurance.",
    },
    loan: {
        phoneLabel: "J'accepte d'être contacté(e) par téléphone.",
        phoneSub: "Par Réassurez-moi (ORIAS n°13010052) pour traiter ma demande et me présenter leurs offres d'assurance.",
        emailLabel: "J'accepte d'être contacté(e) par email.",
        emailSub: "Pour recevoir les offres, le détail des garanties et traiter votre demande.",
    },
    // les modales de demande de rappel AE mentionnent Réassurez-moi sans son n° ORIAS, que garde l'étape Coordonnées
    loanCallback: {
        phoneLabel: "J'accepte d'être contacté(e) par téléphone.",
        phoneSub: "Par Réassurez-moi, pour traiter ma demande et me présenter leurs offres d'assurance.",
        phoneRequired: true,
        emailLabel: "J'accepte d'être contacté(e) par email.",
        emailSub: "Pour recevoir les offres, le détail des garanties et traiter votre demande.",
    },
    health: {
        phoneLabel: "J'accepte d'être contacté(e) par téléphone.",
        phoneSub: "Par les partenaires de Réassurez-moi, pour traiter ma demande et me présenter leurs offres d'assurance santé.",
        emailLabel: "J'accepte d'être contacté(e) par email.",
    },
    provident: {
        phoneLabel: "J'accepte que Prévoir Vie, partenaire de Réassurez-Moi, me contacte par téléphone pour me présenter ses offres d'assurance",
        emailLabel: "J'accepte que Prévoir Vie, partenaire de Réassurez-Moi, me contacte par email pour me présenter ses offres d'assurance",
    },
}

function CheckboxText({ label, sub, emphasized, required = false }: { label: string; sub?: string; emphasized: boolean; required?: boolean }) {
    if (!emphasized) return <>{label}</>
    const labelNode = (
        <span className="text-[14px] font-bold text-black">
            {label}
            {required && <span className="text-red-600">*</span>}
        </span>
    )
    if (!sub) return labelNode
    return (
        <span className="flex flex-col gap-[5px]">
            {labelNode}
            <span className="text-[12px] font-normal text-[#979797]">{sub}</span>
        </span>
    )
}

interface ContactConsentCheckboxesProps {
    acceptPhoneContact: boolean
    acceptEmailContact?: boolean
    onPhoneContactChange: (checked: boolean) => void
    onEmailContactChange?: (checked: boolean) => void
    showEmail?: boolean
    variant?: ContactConsentVariant
}

export default function ContactConsentCheckboxes({
    acceptPhoneContact,
    acceptEmailContact = false,
    onPhoneContactChange,
    onEmailContactChange,
    showEmail = true,
    variant = "legacy",
}: ContactConsentCheckboxesProps) {
    const copy = COPY[variant]
    const labelClassName = copy.phoneSub ? "!text-black font-normal" : "!text-black !text-[12px] font-normal"
    return (
        <div className="flex flex-col gap-[10px]">
            <div className="flex flex-col gap-5 border border-[#ebedf0] rounded-lg px-[10px] py-5">
                <AppCheckbox
                    fieldName="accept_phone_contact"
                    value={acceptPhoneContact}
                    onChange={onPhoneContactChange}
                    inputClassName="!h-[19px] !w-[19px] !min-w-[19px]"
                    className="items-center"
                    labelClassName={labelClassName}
                >
                    <CheckboxText label={copy.phoneLabel} sub={copy.phoneSub} required={copy.phoneRequired} emphasized={variant !== "legacy"} />
                </AppCheckbox>
                <ConsentRegulatoryNotice />
            </div>
            {showEmail && onEmailContactChange && (
                <div className="border border-[#ebedf0] rounded-lg px-[10px] py-5">
                    <AppCheckbox
                        fieldName="accept_email_contact"
                        value={acceptEmailContact}
                        onChange={onEmailContactChange}
                        inputClassName="!h-[19px] !w-[19px] !min-w-[19px]"
                        className="items-center"
                        labelClassName={labelClassName}
                    >
                        <CheckboxText label={copy.emailLabel} sub={copy.emailSub} emphasized={variant !== "legacy"} />
                    </AppCheckbox>
                </div>
            )}
        </div>
    )
}
